import { createContext, useContext, useState, useCallback, useMemo } from "react";

const LanguageContext = createContext({ lang: "it", setLang: () => {}, tr: (obj) => "" });

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState("it");
  const tr = useCallback(
    (obj) => {
      if (!obj) return "";
      if (typeof obj === "string") return obj;
      return obj[lang] ?? obj.it ?? "";
    },
    [lang]
  );
  const value = useMemo(() => ({ lang, setLang, tr }), [lang, tr]);
  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLang = () => useContext(LanguageContext);
